import { format, parseISO } from 'date-fns';

function toDate(value: string | Date): Date {
  return typeof value === 'string' ? parseISO(value) : value;
}

/** "06 Apr 2026" */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '—';
  return format(toDate(value), 'dd MMM yyyy');
}

/** "06/04/2026" */
export function formatDateDMY(value: string | Date | null | undefined): string {
  if (!value) return 'N/A';
  return format(toDate(value), 'dd/MM/yyyy');
}

/** "06 Apr 2026, 02:35 PM" (viewer's local time) */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '—';
  return format(toDate(value), 'dd MMM yyyy, hh:mm a');
}
